// Excursion booking pre-fill carried by a link (Ask Ridalo -> catalogue -> offer page -> booking form).
// Only what the traveller explicitly gave, and only well-formed: a day (YYYY-MM-DD, a real calendar day) and a party
// (adults 1..30, children / infants 0..30). Anything else is ignored whole - nothing is invented, repaired or rounded.
// The offer page still checks the day (past / blocked by the provider) and the listing's capacity before showing it.

export const EXCURSION_MAX_COUNT = 30;

export function validYmd(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  if (!m) return null;
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
  return d.getUTCFullYear() === +m[1] && d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3] ? value : null;
}

const count = (raw, min) => {
  if (!/^\d{1,2}$/.test(raw || '')) return null;
  const n = parseInt(raw, 10);
  return n >= min && n <= EXCURSION_MAX_COUNT ? n : null;
};

/** URLSearchParams (or a query string) -> { date?, adults?, children?, infants? } with only the valid values. */
export function parseExcursionPrefill(search) {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
  const out = {};
  const date = validYmd(params.get('date'));
  if (date) out.date = date;
  const adults = count(params.get('adults'), 1);
  if (adults !== null) out.adults = adults;
  const children = count(params.get('children'), 0);
  if (children !== null) out.children = children;
  const infants = count(params.get('infants'), 0);
  if (infants !== null) out.infants = infants;
  return out;
}

/** The query string ("date=..&adults=..") to append to an excursion offer link; '' when nothing was given. */
export function excursionPrefillQuery(prefill) {
  const q = new URLSearchParams();
  ['date', 'adults', 'children', 'infants'].forEach((k) => { if (prefill && prefill[k] !== undefined) q.set(k, String(prefill[k])); });
  return q.toString();
}
